module.exports = __webpack_public_path__ + "img/calendar-alt.c6fff2a9.svg";